import { useEffect, useState } from 'react';
import { USER_DATA_KEY } from '@/constants';
import type { UserData } from '@/types';
export const useUserData = () => {
  const [userData, setUserData] = useState<UserData>({
    name: '',
    email: '',
    groups: []
  });
  const [isLoading, setIsLoading] = useState(true);
  useEffect(() => {
    const storedUserData = localStorage.getItem(USER_DATA_KEY);
    if (storedUserData) {
      try {
        const parsedData: UserData = JSON.parse(storedUserData);
        setUserData({
          name: parsedData.name || '',
          email: parsedData.email || '',
          groups: parsedData.groups || []
        });
      } catch {
        setUserData({
          name: '',
          email: '',
          groups: []
        });
      }
    } else {
      setUserData({
        name: '',
        email: '',
        groups: []
      });
    }
    setIsLoading(false);
  }, []);
  return {
    ...userData,
    isLoading
  };
};